const toastConfig = {
  PDP_TOAST: {
    NAME: "PDP_ZOOM_TOAST",
  },
}

export default toastConfig
